import { Alert, Empty } from 'antd';
import { useTranslation } from 'translations/hooks';

import { Performance } from 'business/dashboard/components/performance';
import { isUndefinedOrNull } from 'technical/utils/is-null-or-undefined';
import Loader from 'ui/loader';

import { usePerformanceMetrics } from './use-performance-metrics';

const PerformanceContainer = () => {
  const { t } = useTranslation();
  const { loading, error, metrics } = usePerformanceMetrics();

  if (error) {
    return <Alert message={t('errors.error_generic')} type="error" />;
  }

  if (loading) {
    return <Loader />;
  }

  if (isUndefinedOrNull(metrics)) {
    return <Empty />;
  }

  return (
    <Performance
      dayWithMostRingsBuilt={metrics.dayWithMostRingsBuilt}
      weekWithMostRingsBuilt={metrics.weekWithMostRingsBuilt}
      monthWithMostRingsBuilt={metrics.monthWithMostRingsBuilt}
      fastestExcavation={metrics.fastestExcavation}
      fastestPose={metrics.fastestPose}
    />
  );
};

export default PerformanceContainer;
